import * as defaultImport from "@splunk/visualizations/Events";
export * from "@splunk/visualizations/Events";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
